import React, { useState, useEffect } from 'react';
import moment from 'moment';
import FindCompany from './FindCompany';
import SelectSearch from "react-select-search";
import "../../pages/styles/SelectSearch.css";
import Modal from '../Modal';
import VehiculoAddForm from '../Vehiculos/VehiculoAddForm';
import AddTransportistaForm from '../Transportistas/AddTransportistaForm';
import ItemPicker from './ItemPicker';
import { BotonCrearLetras } from '../Plantillas/Botones';
import { notificarError, notificarMsg } from '../Almacenes/AlmacenNotify';


function Form() {
    const [showModalVehiculo, setShowModalVehiculo] = useState(false);
    const [showModalTransportista, setShowModalTransportista] = useState(false);

    const [vehiculos, setVehiculos] = useState([]);
    const [transportistas, setTransportistas] = useState([]);

    const [fechaTraslado, setFechaTraslado] = useState(new Date().toISOString().split('T')[0]);
    const [remitente, setRemitente] = useState(null);
    const [destinatario, setDestinatario] = useState(null);
    const [vehiculo, setVehiculo] = useState(null);
    const [transportista, setTransportista] = useState(null);
    const [pesoCarga, setPesoCarga] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [items, setItems] = useState([]);
    const [infoSucursal, setInfoSucursal] = useState(null);

    useEffect(() => {
        getInfoSucursal();
        getVehiculos();
        getTransportistas();
    }, []);

    const getInfoSucursal = async () => {
        try {
            const response = await fetch(`/api/guiaRemision/InfoEmpresa`);
            const data = await response.json();
            setInfoSucursal(data[0]);
        } catch (error) {
            console.error(error);
        }

    }

    const getVehiculos = async () => {
        try {
            const response = await fetch('/api/vehiculos/');
            const data = await response.json();
            setVehiculos(data.Vehiculos);
        } catch (error) {
            console.error(error);
        }
    }

    const getTransportistas = async () => {
        try {
            const response = await fetch('/api/transportistas/');
            const data = await response.json();
            setTransportistas(data.Transportistas);
        } catch (error) {
            console.error(error);
        }
    }

    const onRemitenteChange = (remitente) => {
        setRemitente(remitente);
    }

    const onDestinatarioChange = (destinatario) => {
        setDestinatario(destinatario);
    }

    const onSaveVehiculo = (vehiculo) => {
        setVehiculos([...vehiculos, vehiculo.data]);
        setVehiculo(vehiculo.data.IdVehiculo);
        setShowModalVehiculo(false);
    }

    const onSaveTransportista = (transportista) => {
        setTransportistas([...transportistas, transportista.data]);
        setTransportista(transportista.data.IdTransportista);
        setShowModalTransportista(false);
    }

    const validarCampos = () => {
        const hoy = moment().startOf('day');
        if (fechaTraslado) {
            const fechaTrasladoDate = moment(fechaTraslado, 'YYYY-MM-DD').startOf('day');
            if (fechaTrasladoDate.isBefore(hoy)) {
                notificarError("La fecha de inicio de traslado no puede ser anterior al día de hoy");
                return false;
            }
        }

        if (!fechaTraslado) {
            notificarError("La fecha de inicio de traslado es obligatoria");
            return false;
        }

        if (!remitente || !remitente.ruc || !remitente.name || !remitente.ubigeo || !remitente.address) {
            notificarError("Debe completar toda la información del remitente");
            return false;
        }

        if (!destinatario || !destinatario.ruc || !destinatario.name || !destinatario.ubigeo || !destinatario.address) {
            notificarError("Debe completar toda la información del destinatario");
            return false;
        }

        if (!pesoCarga || isNaN(pesoCarga) || parseFloat(pesoCarga) <= 0) {
            notificarError("El peso debe ser un número mayor a 0");
            return false;
        }

        if (!items || items.length === 0) {
            notificarError("Debe agregar al menos un producto");
            return false;
        }

        for (let i = 0; i < items.length; i++) {
            if (!items[i].cantidad || items[i].cantidad <= 0) {
                notificarError(`El producto ${items[i].name} debe tener una cantidad válida`);
                return false;
            }
        }

        return true;
    }

    const onSaveGuiaRemision = async () => {
        if (!validarCampos()) {
            return;
        }

        const payload = {
            IdSucursal: infoSucursal.IdSucursal,
            IdTipoDocumentoSunat: 1,
            fechaEmision: new Date().toISOString().split('T')[0],
            fechaTraslado: fechaTraslado,
            tipoDocRemitente: 6,
            numeroDocRemitente: remitente.ruc,
            razonSocialRemitente: remitente.name,
            codUbigeoRemitente: remitente.ubigeo,
            direccionRemitente: remitente.address,
            tipoDocDestinatario: 6,
            numeroDocDestinatario: destinatario.ruc,
            razonSocialDestinatario: destinatario.name,
            codUbigeoDestinatario: destinatario.ubigeo,
            direccionDestinatario: destinatario.address,
            IdVehiculo: vehiculo || null,
            IdTransportista: transportista || null,
            Peso: parseFloat(pesoCarga),
            observaciones: observaciones.trim(),
            items: items.map(item => ({
                IdPresentacion: item.IdPresentacion,
                IdUnidad: item.unidadMedida,
                Codigo: item.codigo,
                Descripcion: item.descripcion,
                Cantidad: parseInt(item.cantidad),
                Observacion: item.observacion || ""
            }))
        };

        try {
            const response = await fetch('/api/guias-remision-transportista/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json();
                notificarError(errorData.message || "Error al crear la guía de remisión");
                return;
            }

            notificarMsg("Guía de remisión creada exitosamente");
            
            window.location.href = "/guia-remision-transportista";
        } catch (error) {
            notificarError("Error de conexión al crear la guía de remisión");
        }
    }

    if (!infoSucursal) {
        return <div>Cargando...</div>
    }

    return <section className='ventas-fpay-section-vh' style={{ height: '100vh' }}>
        <div className="container pt-5 pb-5">
            <div className="row mb-3">
                <div className="col-12">
                    <div className="caja-fondo-blanco-m-2 p-4">
                        <div className="row">
                            <div className='col-md-6'>
                                <div className='mb-3'>
                                    <p className="text-muted small mb-1">RUC</p>
                                    <h6 className="mb-0">{infoSucursal.Ruc}</h6>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='mb-3'>
                                    <p className="text-muted small mb-1">Razón Social</p>
                                    <h6 className="mb-0">{infoSucursal.RazonSocial}</h6>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <p className="text-muted small mb-1">Sucursal</p>
                                    <p className="mb-0">{infoSucursal.Nombre}</p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <p className="text-muted small mb-1">Dirección</p>
                                    <p className="mb-0">{infoSucursal.Direccion}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <p className="text-muted small mb-1">Fecha de Emisión</p>
                                    <p className="mb-0">{moment().format('DD/MM/YYYY')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="caja-fondo-blanco-m-2">
                        <span className="ml-0 p-0">*Fecha de Inicio de Traslado</span>
                        <div className="input__Almacen">
                            <input name="FechaDeInicioDeTraslado" className="input__linea" type="date" value={fechaTraslado} onChange={(e) => setFechaTraslado(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <FindCompany onChange={onRemitenteChange} subtitle="*Información del remitente" />
            <FindCompany onChange={onDestinatarioChange} subtitle="*Información del destinatario" />

            <div className=" caja-fondo-blanco-m-2">
                <b className="pt-3 mb-3">Vehículo: </b>
                <div className="input__Almacen">
                    <SelectSearch
                        isDisabled
                        name="IdVehiculo"
                        value={vehiculo}
                        onChange={(e) => setVehiculo(e.value)}
                        options={vehiculos.map(vehiculo => ({
                            name: vehiculo.Modelo.concat(', ', vehiculo.Placa),
                            value: vehiculo.IdVehiculo
                        }))}
                        className="select-search-box"
                        placeholder="Seleccionar Vehiculo"

                    />
                    <div className='seccion-btn-verde-mfp'>
                        <button onClick={() => setShowModalVehiculo(true)}
                            className="ml-2 mr-2 btn-verde-mfp seccion-btn-verde-mfp"
                            name="docOrigen" type="button">
                            <span>AGREGAR</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className=" caja-fondo-blanco-m-2">
                <b className="pt-3 mb-3">Conductor </b> <br />

                <div className="input__Almacen">
                    <SelectSearch
                        name="IdTransportista"
                        value={transportista}
                        onChange={(e) => setTransportista(e.value)}
                        options={transportistas.map(transportista => ({
                            name: transportista.Empleado,
                            value: transportista.IdTransportista
                        }))}
                        className="select-search-box"
                        placeholder="Seleccionar Piloto"

                    />
                    <div className='seccion-btn-verde-mfp'>
                        <button onClick={() => setShowModalTransportista(true)}
                            className="ml-2 mr-2 btn-verde-mfp "
                            name="docOrigen" type="button">
                            <span>AGREGAR</span>
                        </button>
                    </div>
                </div>
            </div>

            <ItemPicker onChange={(items) => setItems(items)} />

            <div className="row">
                <div className="col-12">
                    <div className="caja-fondo-blanco-m-2">
                        <span className="ml-0 p-0">*Peso Aprox. de Carga (Kg)</span>
                        <div className="input__Almacen">
                            <input
                                name="ComentarioAdicional"
                                className="input__linea "
                                type="text"
                                value={pesoCarga}
                                onChange={(e) => setPesoCarga(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="caja-fondo-blanco-m-2">
                        <span className="ml-0 p-0">Observaciones</span>
                        <div className="input__Almacen">
                            <input
                                name="ComentarioAdicional"
                                className="input__linea "
                                type="text"
                                value={observaciones}
                                onChange={(e) => setObservaciones(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="seccion-btn-verde-mfp mb-2">
                        <BotonCrearLetras className="ml-3" type="submit" onClick={onSaveGuiaRemision} />
                    </div>
                </div>
            </div>
        </div>

        <Modal title="Agregar vehículo" onClose={() => setShowModalVehiculo(false)}
            isOpen={showModalVehiculo}>
            <VehiculoAddForm onSaveVehiculo={onSaveVehiculo} />
        </Modal>

        <Modal title="Agregar transportista" onClose={() => setShowModalTransportista(false)}
            isOpen={showModalTransportista}>
            <AddTransportistaForm onSaveTransportista={onSaveTransportista} />
        </Modal>
    </section>
}

export default Form;
